import { MapName } from "../reducers/maps/actions";
import { RootState } from "../store";
import { useAppSelector } from "./redux";

export function useMapSlice<M extends MapName>(mapName: M) {
    const lowerFirstMapName = mapName[0].toLowerCase() + mapName.slice(1) as M
    return useAppSelector(
        state => state.maps[lowerFirstMapName]
    ) as RootState['maps'][M]
}
